import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
export function Testimonials() {
  const {
    t,
    lang
  } = useLanguage();
  return <section className="py-24 px-6 bg-surface" data-id="element-177">
      <div className="max-w-5xl mx-auto" data-id="element-178">
        <h2 className="font-serif text-4xl md:text-5xl mb-16 text-center" data-id="element-179">
          {lang === 'es' ? <>
              {t.testimonials.h2Part1}{' '}
              <span className="italic text-coral" data-id="element-180">
                {t.testimonials.h2Italic}
              </span>
            </> : <>
              {t.testimonials.h2Part1}{' '}
              <span className="italic text-coral" data-id="element-181">
                {t.testimonials.h2Italic}
              </span>{' '}
              say
            </>}
        </h2>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-182">
          {t.testimonials.items.map((item, index) => <div key={index} className="p-8 bg-cream border border-taupe rounded-2xl flex flex-col justify-between" data-id="element-183">
              <p className="text-lg text-ink/80 leading-relaxed mb-8 font-serif italic" data-id="element-184">
                "{item.quote}"
              </p>
              <div data-id="element-185">
                <p className="font-medium text-ink" data-id="element-186">{item.author}</p>
                <p className="text-sm text-muted" data-id="element-187">{item.age}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}